// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dispatch-add-note-window .cp-content-wrap form {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/invoices/collection-notes/collection-notes.component.scss"],"names":[],"mappings":"AAEQ;EACI,WAAA;AADZ","sourcesContent":[".dispatch-add-note-window{\n    .cp-content-wrap{\n        form{\n            width:100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
